import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import notifications from "./modules/widgets/notifications";
import grids from "./modules/widgets/grids";
import modals from "./modules/widgets/modals";

import routes from "./modules/routesModule";
import captcha from "./modules/captchaModule";
import password from "./modules/passwordModule";
import account from "./modules/accountModule";
import user from "./modules/userModule";
import profiles from "./modules/profilesModule";
import ProfileCreateModule from "./modules/ProfileCreateModule";
import transportModule from "./modules/transportModule";
import drivModule from "./modules/drivModule";
import route from "./modules/routeModule";
import patientsModule from "./modules/patientsModule";
import unitiesModule from "./modules/unitiesModule";
import tripendModule from "./modules/tripModule";
import stoppingPointsModule from "./modules/stoppingPointsModule";
import AgendaUserModule from "./modules/agendaUserModule";
import agreementModule from "./modules/agreementModule";
import vacanciesModule from "./modules/vacanciesModule";
import travelModule from "./modules/travelModule";
import idleVacanciesModule from "./modules/idleVacanciesModule";
import patientScheduleModule from "./modules/patientScheduleModule";
import scheduleModule from "./modules/scheduleModule";
import loginModule from "./modules/loginModule";
import holidayModule from "./modules/holidayModule";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // WIDGETS
    notifications,
    grids,
    modals,

    // MODULES
    routes,
    unitiesModule,
    patientsModule,
    route,
    transportModule,
    captcha,
    drivModule,
    password,
    account,
    stoppingPointsModule,
    user,
    profiles,
    tripendModule,
    ProfileCreateModule,
    AgendaUserModule,
    agreementModule,
    vacanciesModule,
    travelModule,
    idleVacanciesModule,
    patientScheduleModule,
    scheduleModule,
    loginModule,
    holidayModule,
  },
  plugins: [
    createPersistedState({
      key: "vuex",
      // , 'idleVacanciesModule'
      paths: [
        "unitiesModule",
        "patientsModule",
        "transportModule",
        "agreementModule",
        "AgendaUserModule",
        "vacanciesModule",
        "travelModule",
      ], // persistindo apenas partes específicas dos módulos
    }),
  ],
});
